import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { LoginService } from "../../services/login/login.service";
import { Authenticate } from "../../models/authenticate";
import { Router} from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';


@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class Login implements OnInit {

  // Used to clear validation error states on Material form controls
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;

  loginInformation: FormGroup;
  authenticate: any;
  message: '';
  submitted = false;
  clicked = false;
  tempVar: number;
  showDivHasFiled: boolean = false;
  showDivSubmittalErrorMessage: boolean = false;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private _router: Router,
    private storage: LocalStorageService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,

  ) { }

  ngOnInit() {
    this.loginInformation = this.fb.group({
      uniqueId: ["", Validators.compose([Validators.required, Validators.maxLength(8), Validators.minLength(8), Validators.pattern("^[a-zA-Z0-9]+$")])],
      claimId: ["", Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])]
    })
  }

  get f() { return this.loginInformation.controls; }

  onSubmit() {
    this.submitted = true;
    this.showDivSubmittalErrorMessage = false;

    // stop here if form is invalid
    if (this.loginInformation.invalid) {
      this.clicked = false;
      return;
    }

    this.clicked = true;
    const au = this.loginInformation.value;

    this.spinner.show();

    this.Login(au);
  }

  Login(au: Authenticate) {
    this.loginService.login(au).subscribe({
      next: (res) => {
        this.authenticate = res;

        if (this.authenticate !== null) {
          this.storage.store('authenticatedUser', this.authenticate);
          this._router.navigate(['/file-noticed']);
        }
        //else if (this.authenticate.hasFiled === true) {
        //  this.showDivHasFiled = true;

        //  this.toastr.error('You have already submitted your maximum alloted times', 'Info Already Saved', {
        //    timeOut: 5000,
        //    positionClass: 'toast-bottom-full-width',
        //    progressBar: true
        //  });
        //}

        // cleanup
        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
        this.loginInformation.get('claimId').clearValidators();
        this.loginInformation.get('claimId').updateValueAndValidity();
        this.loginInformation.get('uniqueId').clearValidators();
        this.loginInformation.get('uniqueId').updateValueAndValidity();
      },

      error: (err) => {
        if (err.status === 400 ) {
          this.showDivSubmittalErrorMessage = true;
          this.toastr.error('User not found', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        } else {
          this.toastr.error('Something went wrong, Please Check Again', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
      }
    });
  }
}
